import { styled } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';

export const StyledSwiper = styled(Swiper)`
    width: 100%;
    box-sizing: border-box;
    flex-grow: 1;

    & .swiper-slide {
        width: 15rem;
    }
`;

interface StyledLoaderSwiperSlideProps {
  isRemoving?: boolean;
}

export const StyledLoaderSwiperSlide = styled(SwiperSlide, {
  shouldForwardProp: (prop) => prop !== 'isRemoving',
})<StyledLoaderSwiperSlideProps>`
    display: flex;
    width: 2.5rem !important;
    height: 8rem;
    justify-content: center;
    align-items: center;

    animation: ${props => props.isRemoving ? 'scaleOut' : 'scaleIn'} 0.3s ease-in-out;

    @keyframes scaleIn {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }

    @keyframes scaleOut {
        from {
            transform: scale(1);
        }
        to {
            transform: scale(0);
        }
    }
`;